import CrudStoreBuilder from "../common/CrudStoreBuilder";
import roomService from "@/services/salles/RoomService";

const getters = {
  getRoomsByCenterId: (state) => (centerId) => {
    return state.rooms.filter((room) => room.center.id === centerId);
  },
  getRoomsByCenter: (state) => (center) => {
    return state.rooms.filter((room) => room.center.id === center.id);
  },
  getUnavailableRoomsByCenter: (state) => (center) => {
    return state.rooms.filter(
      (room) => room.center.id === center.id && !room.available
    );
  },
  getAvailableRoomsByCenter: (state) => (center) => {
    return state.rooms.filter(
      (room) => room.center.id === center.id && room.available
    );
  },
};

const actions = {
  async loadRoom({ rootGetters }, room) {
    const v = {
      center: rootGetters["centerModule/getCenterById"](room.centerId),
      ...room,
    };
    v.partialCapacity = Math.ceil(v.fullCapacity / 2);
    v.roomCapacity = v.center.partialCap ? room.reducedCapacity: room.fullCapacity;
    return v;
  },
};

export default new CrudStoreBuilder()
  .setName("room")
  .setService(roomService)
  .setDependents(["center"])
  .setConverter((x) => {
    x.centerId = x.center.id;
  })
  .includeGetters(getters)
  .includeActions(actions)
  .build();
